exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table.v-table tbody td[data-v-2dcb5045]:first-child,table.v-table tbody td[data-v-2dcb5045]:not(:first-child),table.v-table tbody th[data-v-2dcb5045]:first-child,table.v-table tbody th[data-v-2dcb5045]:not(:first-child),table.v-table thead td[data-v-2dcb5045]:first-child,table.v-table thead td[data-v-2dcb5045]:not(:first-child),table.v-table thead th[data-v-2dcb5045]:first-child,table.v-table thead th[data-v-2dcb5045]:not(:first-child){padding:0 10px}", ""]);

// exports
